export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/shigonghetongyufukuanbaoxian-92f6674ae3495a2eceec957e124d3d82.png";